import { lazy, Suspense, useEffect } from 'react';

import { useQueries } from '@tanstack/react-query';
import { Routes, Route, useLocation, useNavigate } from 'react-router';

import { LoadingScreen } from '@/components';
import { LEAGUE_KEY } from '@/constants';
import { withPaywall } from '@/hoc';
import { useBusinessData } from '@/hooks';
import { cuInfoQuery, paywallQuery } from '@/query';
import { APP_ROUTES } from '@/routes';
import { AppDataQueryResult } from '@/types';

const CDFIReport = lazy(() => import('@/pages/CDFIReport'));
const CDFICertification = lazy(() => import('@/pages/CDFICertification'));
const NotFoundPage = lazy(() => import('@/pages/Page404'));

export function Router() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setCUData, setIsLeague } = useBusinessData();

  const resultData = useQueries({
    queries: [paywallQuery(), cuInfoQuery()],
  }) as AppDataQueryResult;

  const [{ data: paywallData }, { data: cuInfoData }] = resultData;

  useEffect(() => {
    if (cuInfoData) {
      setCUData(cuInfoData.result);
      setIsLeague(LEAGUE_KEY === cuInfoData.result.organisationType);
    }
  }, [cuInfoData]);

  useEffect(() => {
    if (location.pathname === APP_ROUTES.default) {
      navigate(APP_ROUTES.cdfiCertification, { replace: true });
    }
  }, [location.pathname]);

  return (
    <Suspense fallback={<LoadingScreen />}>
      <Routes>
        <Route path={APP_ROUTES.cdfiReport} element={withPaywall(<CDFIReport />)(APP_ROUTES.cdfiReport, paywallData)} />
        <Route
          path={APP_ROUTES.cdfiCertification}
          element={withPaywall(<CDFICertification />)(APP_ROUTES.cdfiCertification, paywallData)}
        />
        <Route path={APP_ROUTES.catchAll} element={<NotFoundPage />} />
      </Routes>
    </Suspense>
  );
}
